import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';

@Component({
  selector: 'app-poliza-activa',
  templateUrl: './poliza-activa.component.html',
  styleUrl: './poliza-activa.component.scss'
})
export class PolizaActivaComponent {
  private store = inject(Store);
  router = inject(Router);

  cleanStore(){
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  goBack(){
    this.cleanStore();
    this.router.navigate(['/seguros/hogar/arriendo/cotizador']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }
}
